import {
  isSupportedLanguage,
  LOCALE_QUERY_KEY,
  LOCALE_STORAGE_KEY,
  SHARED_LOCALE_COOKIE,
  SHARED_LOCALE_COOKIE_DOMAIN,
  type SupportedLanguage,
} from '../config/languages';

export { LOCALE_STORAGE_KEY };

const cookieDomain = (): string => {
  const host = window.location.hostname;
  if (host === 'paygatex.io' || host.endsWith('.paygatex.io')) {
    return `; Domain=${SHARED_LOCALE_COOKIE_DOMAIN}`;
  }
  return '';
};

export const readSharedLocaleCookie = (): SupportedLanguage | null => {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(?:^|; )${SHARED_LOCALE_COOKIE}=([^;]*)`));
  const value = match?.[1] ? decodeURIComponent(match[1]) : null;
  return isSupportedLanguage(value) ? value : null;
};

export const writeSharedLocaleCookie = (value: SupportedLanguage): void => {
  if (typeof document === 'undefined') return;
  const secure = window.location.protocol === 'https:' ? '; Secure' : '';
  document.cookie = `${SHARED_LOCALE_COOKIE}=${encodeURIComponent(value)}; Path=/; Max-Age=31536000; SameSite=Lax${cookieDomain()}${secure}`;
};

export const readLocaleFromLocation = (): SupportedLanguage | null => {
  const fromQuery = new URLSearchParams(window.location.search).get(LOCALE_QUERY_KEY);
  return isSupportedLanguage(fromQuery) ? fromQuery : null;
};

export const writeLocaleToLocation = (value: SupportedLanguage): void => {
  const url = new URL(window.location.href);
  url.searchParams.set(LOCALE_QUERY_KEY, value);
  window.history.replaceState(window.history.state, '', `${url.pathname}${url.search}${url.hash}`);
};

export const htmlLang = (value: string): string => {
  if (value.startsWith('pt')) return 'pt-BR';
  if (value.startsWith('fr')) return 'fr';
  if (value.startsWith('es')) return 'es';
  if (value.startsWith('ru')) return 'ru';
  return 'en';
};

export const applyDocumentLang = (value: string): void => {
  document.documentElement.lang = htmlLang(value);
};

export const persistLanguage = (value: string): void => {
  if (!isSupportedLanguage(value)) return;
  localStorage.setItem(LOCALE_STORAGE_KEY, value);
  localStorage.setItem(SHARED_LOCALE_COOKIE, value);
  writeSharedLocaleCookie(value);
  writeLocaleToLocation(value);
  applyDocumentLang(value);
};
